module.exports = __webpack_public_path__ + "static/media/Slice1@2x.9bc7aa42.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice1@2x.png
// module id = 1406
// module chunks = 0